import {useEffect, useState} from "react";
import httpService from "../services/httpService"; // your axios wrapper
import posthog from 'posthog-js';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Image from 'react-bootstrap/Image';
import { useNavigate, Link } from "react-router-dom";

import { useAuthStore } from '../store/store';
import { redeemPendingInvite } from '../utils/pendingInvite';
import SsoComponent from "../components/SsoComponent";
import {FaArrowRightFromBracket, FaRegCircleCheck, FaSpinner} from "react-icons/fa6";
import AnimatedImage from "../components/AnimatedImage";
import {makeSignupData} from "../utils/dummyDataGenrators";


const Login = () => {
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        email: "",
        password: ""
    });

    const [errors, setErrors] = useState({
        email: "",
        password: ""
    });

    const navigate = useNavigate();
    const setToken = useAuthStore(state => state.setToken);
    const setUser = useAuthStore(state => state.setUser);
    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        setLoading(true)
        e.preventDefault();
        try {
            const res = await httpService.post("login", formData);
            console.log("User registered:", res.data);

            // Optional: Store token in localStorage
            // localStorage.setItem("token", res.data.token);
            setToken(res.data.token)
            setUser(res.data.user)
            posthog.identify(String(res.data.user.user_id), {
                email: formData.email,
                name: res.data.user.first_name,
                role: res.data.role,
            });
            posthog.capture('user_logged_in', {
                role: res.data.role,
                flow: res.data.flow,
            });
            // amd redirect to dashboard page
            let route = '';
            if(res.data.role === 'podcaster'){
                if(res.data.flow === 'dashboard'){
                    route = '/podcaster-dashboard'
                } else {
                    route = "/wizard/start"
                }
            }

            if(res.data.role === 'listener'){
                if(res.data.flow === 'dashboard'){
                    route = '/listener-dashboard'
                } else {
                    route = "/listener/start"
                }
            }

            // If user arrived via invite flow, redeem the stored token now that they're logged in
            if (await redeemPendingInvite(navigate)) return;

            navigate(route);
        } catch (err) {
            // console.error("Signup error message:", err.response.data.message);
            // console.error("Signup errors:", err.response.data.errors);
            posthog.captureException(err, { tags: { context: 'login' } });
            setErrors(err.response.data.errors)
        } finally {
            setLoading(false)
        }
    };

    useEffect(() => {
        if(process.env.NODE_ENV === 'development'){
            setFormData({
                email: "kevin@podsy.io",
                password: "Password1!"
            });
        }
    }, []);

    return (
        <Container className="d-flex justify-content-center align-items-center p-5">
            <Row className="w-100 justify-content-center">
                <Col xs={12} sm={10} md={8} lg={6} xl={5}>
                    <Card style={{ overflow: 'hidden' }}>
                        <Row className="g-0">
                            <Col>
                                <div className='p-3'>
                                    <div className={'position-absolute'}>
                                        <Link to="/"><FaArrowRightFromBracket /></Link>
                                    </div>
                                    <div className={'text-center'}>
                                        <AnimatedImage
                                            src="/img/podsy-logo-w-200.png"
                                            fluid
                                            alt="Podsy Logo"
                                            loopMs={3000}      // speed of the float loop
                                            aberration={true}  // toggle chromatic aberration
                                            className="" // your sizing classes
                                        />
                                    </div>
                                    <Form className='text-left' onSubmit={handleSubmit}>
                                        <Form.Group className="mb-2" controlId="Email">
                                            <Form.Label>Email address</Form.Label>
                                            <Form.Control
                                                name={'email'}
                                                type="email"
                                                disabled={loading}
                                                placeholder="Enter email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                isInvalid={!!errors.email}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.email?.[0]}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group className="mb-2" controlId="Password">
                                            <Form.Label>Password</Form.Label>
                                            <Form.Control
                                                name={'password'}
                                                type="password"
                                                disabled={loading}
                                                placeholder="Password"
                                                value={formData.password}
                                                onChange={handleChange}
                                                isInvalid={!!errors.password}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {errors.password?.[0]}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <div className="text-end mb-3">
                                            <Link to="/forgot-password" className="small">Forgot password?</Link>
                                        </div>
                                        <Button disabled={loading} className="w-100 mb-3" variant="light" type="submit">
                                            {loading ? <FaSpinner className={"loading_spinner"} /> : 'Login'}
                                        </Button>
                                        <Row className={'mt-1 text-center'}>
                                            <Col><hr/></Col>
                                            <Col>
                                                or continue with
                                            </Col>
                                            <Col><hr/></Col>
                                        </Row>
                                    </Form>
                                    <SsoComponent />
                                    <Row className={'mt-3 text-center'}>
                                        <Col>
                                            You don't have an account ? <Link to="/signup">sign up</Link>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default Login;
